import { createEntityStore, type EntityState, type EntityStore } from '@datorama/akita';
import { type Feature } from 'types/models';

export type FeaturesState = EntityState<Feature>;

const store: EntityStore<FeaturesState> = createEntityStore({}, { resettable: true, name: 'features' });

export default store;
